// src/contexts/Context/slices/useOptionsSlice.js
import { useEffect, useMemo, useState } from "react";
import { Emission_Detail_Options } from "../../../db_access/emission_detail_options";
import { Env_Factor_Options } from "../../../db_access/env_factor_options";
import { buildEmissionDetailOptions, buildEnvFactorOptions } from "../Helpers/buildOptions";

export const useOptionsSlice = () => {
  const [envFactorOptions, setEnvFactorOptions] = useState({});
  const [emissionDetailOptions, setEmissionDetailOptions] = useState({});

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      // Don't fetch options if the user is not logged in (e.g. on the Login page).
      // This prevents 401 redirect loops on the login screen.
      if (!localStorage.getItem("user")) {
        return;
      }

      try {
        console.log("[useOptionsSlice] Fetching emissionDetailOptions and envFactorOptions...");
        const [emissionData, envData] = await Promise.all([Emission_Detail_Options.getAll().then((res) => res.json()), Env_Factor_Options.getAll().then((res) => res.json())]);

        if (cancelled) return;

        console.log("[useOptionsSlice] emissionDetailOptions raw count:", Array.isArray(emissionData) ? emissionData.length : "invalid", "| envFactorOptions raw count:", Array.isArray(envData) ? envData.length : "invalid");
        if (Array.isArray(emissionData)) setEmissionDetailOptions(buildEmissionDetailOptions(emissionData));
        if (Array.isArray(envData)) setEnvFactorOptions(buildEnvFactorOptions(envData));
      } catch (e) {
        console.error("[useOptionsSlice] Failed to load options:", e);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(
    () => ({
      envFactorOptions,
      emissionDetailOptions,
    }),
    [envFactorOptions, emissionDetailOptions]
  );
};
